import { render, staticRenderFns } from "./BundleSection.vue?vue&type=template&id=16e05024&"
import script from "./BundleSection.vue?vue&type=script&lang=js&"
export * from "./BundleSection.vue?vue&type=script&lang=js&"
import style0 from "./BundleSection.vue?vue&type=style&index=0&id=16e05024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports